import { Check } from 'lucide-react';
import { createFileRoute } from '@tanstack/react-router';
import { m } from '@/paraglide/messages.js';
import { Card, CardContent } from '@/components/ui/card';

export const Route = createFileRoute('/_authenticated/complete/$submissionId')({
  component: CompletePage,
});

function CompletePage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-2xl">
        <Card>
          <CardContent className="py-12 text-center">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <Check className="h-6 w-6 text-green-600" />
            </div>
            <h2 className="mt-4 text-xl font-semibold">
              {m.questionnaire_submittedSuccess()}
            </h2>
            <p className="mt-4 text-sm text-muted-foreground">
              {m.questionnaire_canClosePage()}
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
